import { defineComponent, onMounted, reactive } from '@vue/composition-api';
import vueRouter from '@/router/index';
import { useTitle } from '@/shared/hooks/useTitle';
import { useUser } from '@/shared/hooks/useUser';
import { Typography } from '@/components/parts';

// リアクティブな変数の型定義
type ReactiveData = {
  password: string;
};

export default defineComponent({
  components: { Typography },
  setup() {
    const { setTitle } = useTitle();
    const { login: loginAction } = useUser();

    const router = vueRouter; // ルータ
    // リアクティブな変数定義
    const state = reactive<ReactiveData>({
      password: '',
    });

    onMounted(() => {
      setTitle({ title: '', icon: '' });
    });

    /**
     * 学校一覧画面へ遷移する
     */
    const navigationList = () => {
      // 学校一覧画面へ遷移する
      router.push('/result-publication/schools');
    };

    const login = () => {
      if (!state.password) return;
      loginAction({ password: state.password, is_admin: 0 });
    };

    const handleSubmit = (e: KeyboardEvent) => {
      if (e.keyCode === 13) {
        login();
      }
    };

    return {
      state,
      navigationList,
      login,
      handleSubmit,
    };
  },
});
